module.exports = __webpack_public_path__ + "static/media/tron_4.762b0a74.gif";